import { createAction, props } from '@ngrx/store';

import { GadgetGuideRequest as IGadgetGuideRequest } from 'src/app/features/gadget-guide/services/gadget-guide.types';

export const GadgetGuideRequest = createAction(
  '[Audio Video Check] GadgetGuide Request',
  props<{ payload: { [sha256: string]: IGadgetGuideRequest } }>()
);

export const GadgetGuideRequestSuccess = createAction(
  '[Audio Video Check] GadgetGuide Request Success',
  props<{ payload: { [sha256: string]: IGadgetGuideRequest }; response: any }>()
);

export const GadgetGuideRequestFailure = createAction(
  '[Audio Video Check] GadgetGuide Request Failure',
  props<{ payload: { [sha256: string]: IGadgetGuideRequest }; error: any }>()
);
